import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
// import './style.css';
import 'react-toastify/dist/ReactToastify.css';
import "react-responsive-carousel/lib/styles/carousel.min.css";


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <App />
  // </React.StrictMode>
);


<div id='root'></div>